<template>
  <!-- forget password  -->
  <div
    class="modal fade"
    v-show="forgetPassword"
    id="sendModal"
    aria-hidden="true"
    aria-labelledby="exampleModalToggleLabel2"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <button
          type="button"
          class="close-model-btn"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <i class="fa-regular fa-circle-xmark"></i>
        </button>

        <div class="content-model-me">
          <div class="modal-header">
            <h2 class="section-title">كود التفعيل</h2>
          </div>

          <form
            action=""
            class="modal-form"
            @submit.prevent="sendCode()"
            ref="sendCode"
          >
            <div class="modal-body">
              <h4 class="form-title">
                برجاء ادخال رقم الجوال او البريد الالكتروني
              </h4>

              <div class="login-method-toggle d-flex justify-content-center mb-4">
                <button
                  type="button"
                  class="toggle-btn"
                  :class="{ active: recoveryMethod === 'phone' }"
                  @click="recoveryMethod = 'phone'; phone_or_email = ''"
                >
                  رقم الجوال
                </button>
                <button
                  type="button"
                  class="toggle-btn"
                  :class="{ active: recoveryMethod === 'email' }"
                  @click="recoveryMethod = 'email'; phone_or_email = ''"
                >
                  البريد الإلكتروني
                </button>
              </div>

              <div class="inputs-container">
                <div class="input-g">
                  <label for="fp_phone_or_email" class="main-label">
                    {{ recoveryMethod === "phone" ? "رقم الجوال" : "البريد الإلكتروني" }}
                  </label>
                  <div class="main-input phone-input-group">
                    <select
                      v-if="recoveryMethod === 'phone'"
                      class="country-code-select"
                      v-model="phoneCountryCode"
                      aria-label="كود الدولة"
                    >
                      <option v-for="c in countryCodes" :key="c.code" :value="c.code">
                        {{ formatCodeLabel(c) }}
                      </option>
                    </select>
                    <input
                      type="text"
                      class="input-me"
                      :class="{ 'email-mode': recoveryMethod === 'email' }"
                      :placeholder="recoveryMethod === 'phone' ? 'أدخل رقم الجوال' : 'أدخل البريد الإلكتروني'"
                      name="phone_or_email"
                      id="fp_phone_or_email"
                      :autocomplete="recoveryMethod === 'phone' ? 'tel' : 'email'"
                      v-model="phone_or_email"
                      @input="phone_or_email = convertDigits($event.target.value)"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button class="main-btn md up blabla" :disabled="disabled">
                إرسال
                <div class="spinner-border" role="status" v-if="disabled">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- activation code  -->
  <v-dialog v-model="dialog" width="auto" persistent>
    <v-card>
      <div class="d-flex justify-content-end w-100">
        <button
          type="button"
          class="close-model-btn"
          style="font-size: 22px"
          @click="dialog = false"
        >
          <i class="fa-regular fa-circle-xmark"></i>
        </button>
      </div>

      <div class="modal-header">
        <h2 class="section-title">كود التفعيل</h2>
      </div>

      <form class="modal-form" @submit.prevent="sendOtp()">
        <div class="modal-body">
          <h4 class="form-title">برجاء ادخال كود التفعيل المرسل إليك</h4>

          <div class="code-container">
            <v-otp-input
              ref="otpInput"
              input-classes="otp-input"
              style="flex-direction: row-reverse"
              separator=" "
              :num-inputs="4"
              :should-auto-focus="true"
              name="otpInput"
              :is-input-num="true"
              @on-change="handleOnChange"
              @on-complete="handleOnComplete"
            />
          </div>
        </div>

        <div class="modal-footer">
          <button
            class="main-btn md up mx-auto"
            :disabled="disabled"
            type="submit"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            إرسال
            <div class="spinner-border" role="status" v-if="disabled">
              <span class="visually-hidden">Loading...</span>
            </div>
          </button>
        </div>

        <div class="reg text-center">
          <button
            type="button"
            class="reg-anchor"
            :disabled="disabled"
            @click="resendCode()"
          >
            لم تستلم الكود بعد ؟ <span>أعد إرسال الكود</span>
          </button>
        </div>
      </form>
    </v-card>
  </v-dialog>

  <!-- reset password  -->

  <v-dialog v-model="dialog1" width="auto" persistent>
    <v-card>
      <div class="d-flex justify-content-end w-100">
        <button
          type="button"
          class="close-model-btn"
          style="font-size: 22px"
          @click="dialog1 = false"
        >
          <i class="fa-regular fa-circle-xmark"></i>
        </button>
      </div>

      <div class="modal-header">
        <h2 class="section-title">كود التفعيل</h2>
      </div>

      <form class="modal-form" @submit.prevent="resetPassword()">
        <div class="input-g">
          <label for="fp_new_password" class="main-label"> كلمة المرور الجديدة </label>
          <div class="main-input">
            <span class="pass-icon main-icon" @click="switchVisibility()">
              <font-awesome-icon
                icon="fa-solid fa-eye-slash"
                v-if="!eyeToggle"
              />
              <font-awesome-icon icon="fa-solid fa-eye" v-else-if="eyeToggle" />
            </span>
            <input
              name="password"
              :type="passwordFieldType"
              class="input-me"
              placeholder="أدخل كلمة المرور"
              id="fp_new_password"
              autocomplete="new-password"
              v-model="password"
            />
          </div>
        </div>

        <div class="input-g">
          <label for="fp_confirm_password" class="main-label"> تأكيد كلمة المرور الجديدة </label>
          <div class="main-input">
            <span class="pass-icon main-icon" @click="switchVisibility1()">
              <font-awesome-icon
                icon="fa-solid fa-eye-slash"
                v-if="!eyeToggle1"
              />
              <font-awesome-icon
                icon="fa-solid fa-eye"
                v-else-if="eyeToggle1"
              />
            </span>
            <input
              name="password_confirmation"
              :type="passwordFieldType1"
              class="input-me"
              placeholder="أدخل كلمة المرور مرة أخرى"
              id="fp_confirm_password"
              autocomplete="new-password"
              v-model="password_confirmation"
            />
          </div>
        </div>

        <div class="modal-footer">
          <button
            class="main-btn md up mx-auto"
            :disabled="disabled"
            type="submit"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            إرسال
            <div class="spinner-border" role="status" v-if="disabled">
              <span class="visually-hidden">Loading...</span>
            </div>
          </button>
        </div>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import VOtpInput from "vue3-otp-input";

import { mapState, mapMutations, mapGetters } from "vuex";

export default {
  data() {
    return {
      recoveryMethod: "phone",
      phone_or_email: "",
      dialog: false,

      dialog1: false,

      disabled: false,
      forgetPassword: false,

      password: "",
      password_confirmation: "",
      phoneCountryCode: "+966",
      countryCodes: [{ name: "السعودية", code: "+966" }],
    };
  },
  components: {
    VOtpInput,
  },
  setup() {
    const otpInput = null;

    const handleOnComplete = (value) => {
      console.log("OTP completed: ", value);
    };

    const handleOnChange = (value) => {
      console.log("OTP changed: ", value);
    };

    return { handleOnComplete, handleOnChange, otpInput };
  },

  computed: {
    ...mapState(["eyeToggle"]),
    ...mapGetters(["eyeToggle"]),
    ...mapState(["passwordFieldType"]),
    ...mapGetters(["passwordFieldType"]),
    ...mapState(["eyeToggle1"]),
    ...mapGetters(["eyeToggle1"]),
    ...mapState(["passwordFieldType1"]),
    ...mapGetters(["passwordFieldType1"]),
  },
  methods: {
    convertDigits(value) {
      if (!value) return value;
      const map = {
        "٠": "0",
        "١": "1",
        "٢": "2",
        "٣": "3",
        "٤": "4",
        "٥": "5",
        "٦": "6",
        "٧": "7",
        "٨": "8",
        "٩": "9",
      };
      return value.replace(/[٠-٩]/g, function (d) {
        return map[d];
      });
    },
    formatCodeLabel(c) {
      const code = String(c.code || "").replace("+", "");
      return `+${code}`;
    },
    normalizeLocalPhone(value) {
      const raw = String(value || "").replace(/\s+/g, "");
      const digits = raw.replace(/[^\d+]/g, "");
      let v = digits.startsWith("+") ? digits.slice(1) : digits;
      v = v.replace(/^0+/, "");
      const code = String(this.phoneCountryCode || "").replace(/[^\d]/g, "");
      if (code && v.startsWith(code)) v = v.slice(code.length);
      v = v.replace(/^0+/, "");
      return v;
    },
    getRecoveryIdentifier() {
      const raw = String(this.phone_or_email || "").trim();
      if (this.recoveryMethod === "email") {
        return raw.toLowerCase();
      }

      return this.normalizeLocalPhone(raw);
    },
    // forget password
    async sendCode() {
      this.disabled = true;
      const fd = new FormData();
      fd.append("phone_or_email", this.getRecoveryIdentifier());

      await axios
        .post("forget-password", fd)
        .then((res) => {
          if (res.data.key == "success") {
            this.$swal({
              icon: "success",
              title: res.data.msg,
              timer: 2000,
              showConfirmButton: false,
            });

            this.forgetPassword = false;
            document.querySelector(".modal-backdrop").style.display = "none";

            setTimeout(() => {
              this.dialog = true;
            }, 2000);

            localStorage.setItem("forget_phone_or_email", this.getRecoveryIdentifier());
          } else {
            this.$swal({
              icon: "error",
              title: res.data.msg,
              timer: 2000,
              showConfirmButton: false,
            });
          }

          this.disabled = false;
        })
        .catch((err) => {
          console.error(err);
        });
    },

    // send active code
    async sendOtp() {
      const fd = new FormData();
      fd.append("phone_or_email", localStorage.getItem("forget_phone_or_email"));

      let otpString = JSON.stringify(this.$refs.otpInput.otp.join(""));
      let otpsNumber = JSON.parse(otpString);

      fd.append("code", otpsNumber);

      await axios.post("check-code", fd).then((res) => {
        if (res.data.key == "success") {
          this.$swal({
            icon: "success",
            title: res.data.msg,
            timer: 2000,
            showConfirmButton: false,
          });

          this.dialog1 = true;
        } else {
          this.$swal({
            icon: "error",
            title: res.data.msg,
            timer: 2000,
            showConfirmButton: false,
          });
        }

        this.disabled = false;
        this.dialog = false;
      });
    },

    // resend code
    async resendCode() {
      const fd = new FormData();
      fd.append("phone_or_email", localStorage.getItem("forget_phone_or_email"));

      await axios
        .post("resend-code", fd)
        .then((res) => {
          if (res.data.key == "success") {
            this.$swal({
              icon: "success",
              title: res.data.msg,
              timer: 2000,
              showConfirmButton: false,
            });
          } else {
            this.$swal({
              icon: "error",
              title: res.data.msg,
              timer: 2000,
              showConfirmButton: false,
            });
          }
        });
    },

    // reset password
    async resetPassword() {
      const fd = new FormData();

      fd.append("phone_or_email", localStorage.getItem("forget_phone_or_email"));
      fd.append("password", this.password);
      fd.append("password_confirmation", this.password_confirmation);

      await axios.post("reset-password", fd).then((res) => {
        if (res.data.key == "success") {
          this.$swal({
            icon: "success",
            title: res.data.msg,
            timer: 2000,
            showConfirmButton: false,
          });
          this.dialog1 = false;
        } else {
          this.$swal({
            icon: "error",
            title: res.data.msg,
            timer: 2000,
            showConfirmButton: false,
          });
        }
      });
    },

    ...mapMutations(["switchVisibility"]),
    ...mapMutations(["switchVisibility1"]),
  },

  mounted() {
    this.forgetPassword = true;
  },
};
</script>

<style scoped>
.phone-input-group {
  display: flex;
  align-items: center;
  gap: 8px;
  direction: ltr;
  text-align: left;
}

.phone-input-group .country-code-select {
  position: static;
  transform: none;
  height: 40px;
  padding: 2px 8px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #fff;
  color: #333;
  font-size: 12px;
  direction: ltr;
  unicode-bidi: plaintext;
  flex: 0 0 auto;
}

.phone-input-group .input-me {
  padding-left: 12px !important;
  direction: ltr;
  text-align: left;
  unicode-bidi: plaintext;
  flex: 1 1 auto;
  min-width: 0;
}

.phone-input-group .input-me.email-mode {
  padding-left: 12px;
}

.login-method-toggle {
  background: #f8f9fa;
  padding: 4px;
  border-radius: 8px;
  gap: 8px;
}

.toggle-btn {
  flex: 1;
  padding: 8px 16px;
  border: none;
  background: transparent;
  color: #666;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.toggle-btn.active {
  background: #fff;
  color: #2abdc7;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>
